import React from 'react';
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import 'swiper/components/pagination/pagination.min.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.min.css';
import cloudTips from './data.json';
import './style.css';

const CloudTips = () => {
  SwiperCore.use([Pagination, Autoplay]);

  const shuffleTips = cloudTips.sort(() => Math.random() - 0.5);

  return (
    <div className="swiper-container">
      <Swiper
        className="tips-box"
        slidesPerView="auto"
        spaceBetween={32}
        pagination={{
          clickable: true,
        }}
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
        }}
        modules={[Pagination, Autoplay]}
      >
        {shuffleTips.map((data) => (
          <SwiperSlide key={data.content}>{data.content}</SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CloudTips;
